import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from 'rxjs';
import { environment } from "../../environments/environment";
import { Question } from "../models/question.model";

@Injectable({
  providedIn: "root",
})
export class QuestionsService {
  baseURL: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  async findByQuiz(courseId: number, chapterId: number, quizId: number, random?: boolean) {
    return await lastValueFrom(
      this.http
        .get<Array<Question>>(`${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions`, {
          params: { random: random ? 'true' : 'false' }
        })
    );
  }

  async findById(courseId: number, chapterId: number, quizId: number, questionId: number) {
    return await lastValueFrom(
      this.http
        .get<Question>(`${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions/${questionId}`)
    );
  }

  async create(courseId: number, chapterId: number, quizId: number, data) {
    return await lastValueFrom(
      this.http.post(`${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions`, data)
    );
  }

  async update(courseId: number, chapterId: number, quizId: number, questionId: number, data) {
    return await lastValueFrom(
      this.http
        .put(`${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions/${questionId}`, data)
    );
  }

  async delete(courseId: number, chapterId: number, quizId: number, questionId: number) {
    return await lastValueFrom(
      this.http
        .delete(`${environment.apiUrl}/courses/${courseId}/chapters/${chapterId}/quizzes/${quizId}/questions/${questionId}`)
    );
  }
}
